import React, { useState, useEffect } from 'react';
import countryService from '../services/countryService';

const CountrySelect = ({ name, value, onChange, disabled, required, placeholder }) => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCountries();
  }, []);

  const fetchCountries = async () => {
    try {
      setLoading(true);
      const response = await countryService.getAllCountries();
      setCountries(response.data.countries || []);
    } catch (err) {
      setError('Failed to load countries');
      console.error('Error fetching countries:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <select name={name} disabled>
        <option>Loading countries...</option>
      </select>
    );
  }

  if (error) {
    return (
      <select name={name} disabled>
        <option>Error loading countries</option>
      </select>
    );
  }

  return (
    <select
      name={name}
      value={value || ''}
      onChange={onChange}
      disabled={disabled}
      required={required}
    >
      <option value="">{placeholder || 'Select a country...'}</option>
      {countries.map(country => (
        <option key={country.code} value={country.code}>
          {country.description}
        </option>
      ))}
    </select>
  );
};

export default CountrySelect;
